import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_RELATED_TAGS } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubProfileService } from "@/features/LenderHub/Profile/services/profileService";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const addLendingProgramEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    addLendingProgram: builder.mutation({
      query: (body) => ({
        url: "lending-programs",
        method: "POST",
        body,
      }),
      invalidatesTags: LENDING_PROGRAM_RELATED_TAGS,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          sendAnalytics(ANALYTIC_EVENTS.LENDING_PROGRAM_CREATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Lending Program have been created!",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubProfileService.util.invalidateTags(["LenderHubProfile"]));
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useAddLendingProgramMutation } = addLendingProgramEndpoint;

